import Vue from 'vue'
import App from './App'
import router from './router'
import VueResource from 'vue-resource'
import { StripeCheckout } from 'vue-stripe'
import VueAnalytics from 'vue-analytics'

Vue.use(VueResource);
Vue.config.devtools = false;

// asynchronous stripe-checkout
import (/* webpackChunkName: "Vue-Stripe-Checkout" */ 'vue-stripe-checkout').then((checkout) => {
  const options = {
      key: 'pk_test_ki5Bhv3Birs9hckwDsK5TkF8',
      //key: 'pk_live_8ZXJbhQOsPmJ3Hyxv25F5bAa',
      image: 'https://cdn.meme.am/images/100x100/15882140.jpg',
      locale: 'auto',
      currency: 'USD',
      billingAddress: true,
      panelLabel: 'Subscribe {{amount}}'
  }
  checkout.default.install(Vue,options);
});

// Stripe checkout
// import VueStripeCheckout from 'vue-stripe-checkout';
// const options = {
//     key: 'pk_test_AALXrZZqOiiBkI5iuxh9hAd6',
//     image: 'https://cdn.meme.am/images/100x100/15882140.jpg',
//     locale: 'auto',
//     currency: 'USD',
//     billingAddress: true,
//     panelLabel: 'Subscribe {{amount}}'
// }
// Vue.use(VueStripeCheckout, options);

//validation
import VeeValidate from 'vee-validate';
Vue.use(VeeValidate);
VeeValidate.Validator.extend('passphrase', {
    getMessage: field => 'Sorry dude, wrong pass phrase.',
    validate: value => value.toUpperCase() == 'Demogorgon'.toUpperCase()
});
VeeValidate.Validator.extend('verify_password', {
    getMessage: field => `The password must contain at least: 1 uppercase letter, 1 lowercase letter, 1 number, and one special character (E.g. , . _ & ? etc)`,
    validate: value => {
        var strongRegex = new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})");
        return strongRegex.test(value);
    }
});

var VueScrollTo = require('vue-scrollto');

// Vue.use(VueScrollTo)

// You can also pass in the default options
Vue.use(VueScrollTo, {
    container: "body",
    duration: 1000,
    easing: "ease",
    offset: -80,
    cancelable: true,
    onDone: false,
    onCancel: false,
    x: false,
    y: true
})

// media query
import vMediaQuery from 'v-media-query'
Vue.use(vMediaQuery)

//fixed header
import FixedHeader from 'vue-fixed-header'

// import './assets/css/mainB.css'
// import './assets/css/main.css'
// import './assets/css/progress.css'
// import './assets/js/helpers.js'

Vue.config.productionTip = false

Vue.use(VueAnalytics, {
    id: 'UA-112199711-1',
    // id: 'UA-120712909-1',
    router
});


var themeobj = {};
if (localStorage.getItem("themeObject") === null) {
  var randomnumber = Math.floor(Math.random() * (9 - 1 + 1)) + 1;
  // console.log(randomnumber);

  var now = new Date();
  // console.log(now);
  var twoHoursLater = new Date(now.getTime() + (2*1000*60*60));
  // console.log(twoHoursLater);

  themeobj = { 'number': randomnumber, 'date': twoHoursLater };
  localStorage.setItem('themeObject', JSON.stringify(themeobj));
}else{
    var retrievedObject = localStorage.getItem('themeObject');
    var resobj = JSON.parse(retrievedObject);
    themeobj = resobj;
    var exp = new Date(resobj.date);
    var current = new Date();
    if(exp < current){
        var randomnumber = 0;
        var now = new Date();
        // console.log(now);
        var twoHoursLater = new Date(now.getTime() + (2*1000*60*60));
        // console.log(twoHoursLater)

        if((resobj.number === null)){
            // Expired theme case
            randomnumber = Math.floor(Math.random() * (4 + 1));
            // console.log(randomnumber);
        }else{
            if(resobj.number > 10){
                randomnumber = Math.floor(Math.random() * (4 + 1));
            }else{
                randomnumber = parseInt(resobj.number) + 1;
            }
        }

        var themeobj = { 'number': randomnumber, 'date': twoHoursLater };
        localStorage.setItem('themeObject', JSON.stringify(themeobj));
    }
}


console.log(themeobj);
var file = '';
if((themeobj.number%2 == 0)){
    file = './assets/css/main.css';
}else{
    file = './assets/css/mainB.css';
}


// if ( module.hot ) {
//   import(`${file}`).then(data=> {
//     return data;
//   });
// }
// import './assets/css/mainB.css';

import(`${file}`).then((res) => {
    new Vue({
        el: '#app',
        router,
        template: '<App/>',
        components: { App }
    })
});



// WEBPACK FOOTER //
// ./src/main.js